import LceCourseExperienceExperiments from 'bundles/epic/clients/LceCourseExperience';

export const isAdaptiveLearningEnabled = (courseId: string): boolean => {
  // todo: add courseId to the experiment key
  return LceCourseExperienceExperiments.get('isAdaptiveLearningEnabled');
};
